import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import { FormattedMessage, FormattedHTMLMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import detector from "detector";

import { IStateTree } from "../../../store/interfaces";
import { IUser } from "../../../store/user/models";
import routing from "../../../routing";
import { amazonHost } from "../../../paths";

import Button from "../../../components/BigWhiteButton";

import { ButtonWrapper } from "../Hero/styles";

import { Section, Ribbon } from "./styles";

import messages from "./messages";

const isFirefox = process.env.WEBPACK ? detector.browser.name === "firefox" : false;
const dev = process.env.NODE_ENV === "development";

const Features = () => {
    const { locale } = useIntl();
    const user = useSelector((state: IStateTree) => state.user) as IUser;
    const [rotate, setRotate] = useState("");
    const [reversedRotate, setReversedRotate] = useState("");
    const [loaded, setLoaded] = useState(false);

    const resize = useCallback(() => {
        if (window.innerWidth < 768) {
            let deg = (Math.sin(60 / window.innerWidth) * 180) / Math.PI;
            setRotate(`rotate(${deg}deg)`);
            setReversedRotate(`rotate(${-deg}deg)`);
        } else {
            setRotate("");
            setReversedRotate("");
        }
    }, [setRotate, setReversedRotate]);

    useEffect(() => {
        window.addEventListener("resize", resize);
        setTimeout(resize, 100);
        setLoaded(true)
        return () => {
            window.removeEventListener("resize", resize);
        }
    }, []);

    return (
        <Section>
            <Ribbon className={"Ribbon1"} locale={locale}>
                <div className={"RibbonWrapper"}>
                    <div className={"Container"}>
                        <h3>
                            <FormattedMessage {...messages.a1_h3} />
                        </h3>
                        <p>
                            <FormattedHTMLMessage {...messages.a1_d} />
                        </p>
                    </div>
                    {loaded && (
                        <img
                            className={isFirefox ? "Firefox" : undefined}
                            src={dev ? "/local/article1.jpg" : amazonHost + "landing/article1.jpg"}
                            alt="happy teacher and children"
                        ></img>
                    )}
                </div>
                {loaded && (
                    <>
                        <div className={"UpperRibbon"}></div>
                        <div className={"LowerShadow"} style={{ transform: rotate }}></div>
                    </>
                )}
            </Ribbon>
            <Ribbon className={"Ribbon2"} locale={locale}>
                <div className={"RibbonWrapper"}>
                    <div className={"Container"}>
                        <h3>
                            <FormattedMessage {...messages.a2_h3} />
                        </h3>
                        <p>
                            <FormattedHTMLMessage {...messages.a2_d} />
                        </p>
                    </div>
                    {loaded && (
                        <picture>
                            <source
                                srcSet={dev ? "/local/article2-897.webp" : amazonHost + "landing/article2-897.webp"}
                                type="image/webp"
                            />
                            <source
                                srcSet={dev ? "/local/article2-897.png" : amazonHost + "landing/article2-897.png"}
                                type="image/png"
                            />
                            <img
                                src={dev ? "/local/article2-897.png" : amazonHost + "landing/article2-897.png"}
                                alt="happy child using mobile"
                            />
                        </picture>
                    )}
                </div>
                {loaded && (
                    <>
                        <div className={"UpperRibbon"}></div>
                        <div className={"LowerShadow"} style={{ transform: reversedRotate }}></div>
                    </>
                )}
            </Ribbon>
            <Ribbon className={"Ribbon3"} locale={locale}>
                <div className={"RibbonWrapper"}>
                    <div className={"Container"}>
                        <h3>
                            <FormattedMessage {...messages.a3_h3} />
                        </h3>
                        <p>
                            <FormattedMessage {...messages.a3_d} />
                        </p>
                    </div>
                    {loaded && (
                        <picture>
                            <source
                                srcSet={
                                    dev ? "/local/article3-1000.webp" : amazonHost + "landing/article3-1000.webp"
                                }
                                type="image/webp"
                            />
                            <source
                                srcSet={dev ? "/local/article3-1000.png" : amazonHost + "landing/article3-1000.png"}
                                type="image/png"
                            />
                            <img
                                src={dev ? "/local/article3-1000.png" : amazonHost + "landing/article3-1000.png"}
                                alt="teacher using tablet for work"
                            />
                        </picture>
                    )}
                </div>
                {loaded && (
                    <>
                        <div className={"UpperRibbon"}></div>
                        <div className={"LowerShadow"} style={{ transform: rotate }}></div>
                    </>
                )}
            </Ribbon>
            <Ribbon className={"Ribbon4"} locale={locale}>
                <div className={"RibbonWrapper"}>
                    <p>
                        <FormattedHTMLMessage {...messages.join} />
                    </p>
                    <ButtonWrapper>
                        <Link
                            to={
                                "/" +
                                (!user
                                    ? routing.signup
                                    : user.state === "loggedIn"
                                    ? (user.isStudent ? routing.dashboardStudent : routing.dashboard)
                                    : routing.signup)
                            }
                        >
                            <Button className={cn("button", "button--pretty")}>
                                <FormattedMessage {...messages.start} />
                            </Button>
                        </Link>
                    </ButtonWrapper>
                </div>
                {loaded && <div className={"UpperRibbon"}></div>}
            </Ribbon>
        </Section>
    );
}

export default Features;
